import React from 'react';

const ImageModal = ({ src, alt, isOpen, onClose, imageStyle }) => {
  if (!isOpen) return null;

  const isPdf = Boolean(src) && src.toLowerCase().endsWith(".pdf");

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        cursor: 'pointer'
      }}
      onClick={onClose}
    >
      {isPdf ? (
        <iframe
          src={src}
          title={alt}
          style={{
            width: '92vw',
            height: '92vh',
            border: 'none',
            borderRadius: '8px',
            background: '#fff'
          }}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          style={{
            maxHeight: '90vh',
            maxWidth: '90vw',
            objectFit: 'contain',
            borderRadius: '8px',
            ...imageStyle
          }}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default ImageModal; 